let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e3YpS")).then(() => parcelRequire('1Lbz1'));